import { EntityMessage } from "../../entity/EntityMessage";

export class DtoMessagesPostRes extends EntityMessage {}
